<div class="text-center pb-2">
  <h6 class="m-0 pb-1">{{ title | translate }}</h6>
  <div mat-dialog-content class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
